module.exports = __webpack_public_path__ + "img/feature_stops.3bd3a8b6.svg";